import { useState } from 'react';
import { motion } from 'framer-motion';
import { PIECES } from './data';

// PIECES — full catalogue, plate-by-plate. Vertical scroll-list of large plates with caption block.
export default function Pieces() {
  const cats = ['All', ...new Set(PIECES.map(p => p.cat))];
  const [c, setC] = useState('All');
  const list = c === 'All' ? PIECES : PIECES.filter(p => p.cat === c);
  return (
    <div className="bg-[#F2E8D5] text-[#1F3A2E] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1F3A2E]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B5527] mb-3">— Section II / Pieces · 46 plates</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The whole catalogue.</h1>
      </section>
      <div className="border-b border-[#1F3A2E]/15 sticky top-20 bg-[#F2E8D5]/95 backdrop-blur-md z-30">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-4 flex flex-wrap gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          {cats.map(cat => (
            <button key={cat} onClick={() => setC(cat)} data-testid={`vm-cat-${cat}`} className={`px-4 py-1.5 transition-colors ${c === cat ? 'bg-[#1F3A2E] text-[#F2E8D5]' : 'border border-[#1F3A2E]/25 text-[#1F3A2E]/65 hover:border-[#1F3A2E]'}`}>{cat}</button>
          ))}
        </div>
      </div>

      <section className="max-w-[1300px] mx-auto px-8 lg:px-14 py-12 space-y-16">
        {list.map((p, i) => (
          <motion.article key={p.code} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }} className={`grid md:grid-cols-[1fr_320px] gap-10 items-start ${i % 2 ? 'md:grid-cols-[320px_1fr]' : ''}`}>
            <div className={`aspect-[3/4] overflow-hidden border-[3px] border-[#1F3A2E]/15 ${i % 2 ? 'md:order-2' : ''}`}>
              <img src={p.img} alt="" className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-1000" loading="lazy" />
            </div>
            <div className={`pt-6 ${i % 2 ? 'md:order-1' : ''}`}>
              <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527]">Plate {String(i + 1).padStart(2, '0')} · {p.code}</p>
              <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#1F3A2E]/40 mt-1">{p.cat}</p>
              <h2 className="font-serif italic text-3xl lg:text-5xl leading-[1] mt-4">{p.t}</h2>
              <p className="font-serif text-base text-[#1F3A2E]/65 mt-4 leading-[1.7]">{p.d}</p>
              <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-2 font-mono text-[10px] tracking-[0.22em] uppercase text-[#1F3A2E]/65 border-t border-dashed border-[#1F3A2E]/30 pt-4">
                <span>Sizes available</span><span className="text-[#1F3A2E]">{p.sizes}</span>
                <span>Catalogue price</span><span className="text-[#7B5527] font-serif normal-case tracking-normal text-base">{p.price}</span>
              </div>
              <button data-testid={`vm-add-${p.code}`} className="mt-6 bg-[#1F3A2E] text-[#F2E8D5] px-6 py-3 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#7B5527] transition-colors">Reserve plate {String(i + 1).padStart(2, '0')} →</button>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
